module.exports = __webpack_public_path__ + "static/img/25.fc9d623.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/25.jpg
// module id = sKtX
// module chunks = 0